import React from "react";
import { motion } from "framer-motion";

const ScrollReveal = ({ 
  children, 
  className, 
  delay = 0, 
  direction = "bottom", 
  duration = 0.8, // Default duration if not specified
  onClick 
}) => {
  // Determine initial start position based on direction
  let initial = { opacity: 0, y: 30 }; // Default: Slide UP (from bottom)

  if (direction === "top") {
    initial = { opacity: 0, y: -50 }; // Slide DOWN (from top)
  } else if (direction === "left") {
    initial = { opacity: 0, x: -50 }; // Slide RIGHT (from left)
  } else if (direction === "right") {
    initial = { opacity: 0, x: 50 }; // Slide LEFT (from right)
  }

  return (
    <motion.div
      className={className}
      onClick={onClick}
      initial={initial}
      whileInView={{ opacity: 1, y: 0, x: 0 }} // Animate to neutral position
      viewport={{ once: true, amount: 0.1 }} // Trigger when 10% visible
      transition={{
        duration: duration, 
        delay: delay,
        ease: "easeOut",
      }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;